import { BracketPickOption } from "model/Bracket/BracketPickOptions";
import { Pick } from "model/Pickem/Pickem";

export type BracketMatchArgs =
  | BracketMakePicksMatchArgs
  | BracketViewPicksMatchArgs;

export type BracketMakePicksMatchArgs = {
  picks: { [id: string]: Pick };
  updatePick: (matchId: string, teamId: string | undefined) => void;
  pickOptions: BracketPickOption[];
};

export type BracketViewPicksMatchArgs = {
  picks: { [matchId: string]: Pick };
  matchPoints: { [matchId: string]: number } | undefined;
  pickOptions: BracketPickOption[];
};

export const isBracketViewPicksMatchArgs = (
  args: BracketMatchArgs
): args is BracketViewPicksMatchArgs => {
  return (args as BracketViewPicksMatchArgs).picks !== undefined;
};

export const isBracketMakePicksMatchArgs = (
  args: BracketMatchArgs
): args is BracketMakePicksMatchArgs => {
  return (args as BracketMakePicksMatchArgs).updatePick !== undefined;
};
